import { useState, useEffect, useRef } from "react";

// Anime un nombre de sa valeur précédente vers sa nouvelle valeur, avec la
// courbe et la durée du design system ANDAR (ease-out cubique, 1400ms).
// Respecte prefers-reduced-motion (saut direct à la valeur finale).

export function useCompteurAnime(valeurCible, duree = 1400) {
  const [valeurAffichee, setValeurAffichee] = useState(valeurCible ?? 0);
  const valeurPrecedente = useRef(valeurCible ?? 0);

  useEffect(() => {
    if (valeurCible === null || valeurCible === undefined) return;

    const reduitMouvement =
      typeof window !== "undefined" &&
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (reduitMouvement) {
      setValeurAffichee(valeurCible);
      valeurPrecedente.current = valeurCible;
      return;
    }

    const depart = valeurPrecedente.current;
    const arrivee = valeurCible;
    const debutTemps = performance.now();
    let annule = false;

    function animer(tempsActuel) {
      if (annule) return;
      const t = Math.min(1, (tempsActuel - debutTemps) / duree);
      const progression = 1 - Math.pow(1 - t, 3);
      setValeurAffichee(depart + (arrivee - depart) * progression);
      if (t < 1) {
        requestAnimationFrame(animer);
      } else {
        valeurPrecedente.current = arrivee;
      }
    }

    requestAnimationFrame(animer);
    return () => {
      annule = true;
    };
  }, [valeurCible, duree]);

  return valeurAffichee;
}
